import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/modifications',
    name: RouteName.Modifications,
    component: () => import('@/pages/Modifications/Modifications'),
    meta: {
      breadcrumb: {
        label: 'Модификаторы',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/modifications/create',
    name: 'Создать модификатор',
    component: () => import('@/pages/Modifications/ModificationsCreate'),
    meta: {
      breadcrumb: {
        label: 'Новый модификатор',
        parent: RouteName.Modifications,
      },
    },
  },
  {
    path: '/modifications/:id',
    name: 'Модификатор',
    component: () => import('@/pages/Modifications/ModificationsSingle'),
    props: { isEdit: false },
    meta: {
      breadcrumb: {
        label: 'Редактирование модификатора',
        parent: RouteName.Modifications,
      },
    },
  },
]
